var map = {
	"./blog.yml": 158,
	"./cloud.yml": 159,
	"./color.yml": 160,
	"./country.yml": 161,
	"./dio.yml": 162,
	"./doc.yml": 163,
	"./emoji.yml": 164,
	"./git.yml": 165,
	"./icon.yml": 166,
	"./license.yml": 167,
	"./link.yml": 168,
	"./metrics.yml": 169,
	"./people.yml": 170,
	"./soft.yml": 171,
	"./src.yml": 172,
	"./status.yml": 173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 157;